import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarLayout1Container = () => {
  return (
    <>
      <CarBreadcrumb mailClass="style-breadcrumbs-2" type="car_detail" />
      <CarDetail type="car" />
    </>
  );
};

export default CarLayout1Container;
